export default __webpack_public_path__ + "static/broadcastImg6-4c588e4dd0b911126cd7c284d48853a4.webp";